import CreatePaymentPage from './CreatePaymentPage';

export default CreatePaymentPage
